import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';

import { FocusIndicator } from '~shared/components/FocusIndicator';
import { IconImage } from '~shared/components/icons/standard';

import { Props as ImageFieldProps } from './ImageField';
import { localZoneContext } from './ImageFieldDropZone';

type Props = {
  size: ImageFieldProps['size'];
  isZoneActive: boolean;
};

const ImageFieldPlaceholder = (props: Props) => {
  const { size } = props;
  const isLocalZoneActive = React.useContext(localZoneContext);
  const placeholderClass = cx(
    'flex w-full h-full items-center justify-center rounded-1',
    {
      'group-hover:bg-cyan-50': size === 'default',
      'bg-cyan-50': size === 'default' && isLocalZoneActive,
    }
  );

  return (
    <div className={placeholderClass} data-testid="image-field-placeholder">
      {props.size === 'inline' ? (
        <IconImage />
      ) : (
        <>
          <div className="group relative focus:z-10 border-0 rounded-2 text-sm leading-8 font-sans font-600 appearance-none outline-none select-none transition ease-in-out duration-100 cursor-pointer text-cyan-700 bg-transparent hover:bg-cyan-50 focus:bg-cyan-50">
            <div className="relative flex flex-col gap-1 items-center my-2 justify-center">
              <IconImage /> {translate('Drag & Drop or Choose Image')}
            </div>
          </div>
          <FocusIndicator />
        </>
      )}
    </div>
  );
};

export default ImageFieldPlaceholder;
